<template lang="pug">
.list-item.is-flex.is-align-items-stretch.is-justify-content-space-between.p-0.has-background-white.checkout-item(@click="onItemClick" :class="disabled ? '' : 'is-clickable'")    
  div.p-4
    template(v-if="item.type === 'product'")
      p.title.is-5
        product-name-view(:value="item.product")
    template(v-else-if="item.type === 'voucher'")
      p.title.is-5.is-size-5-mobile(v-if="item.voucherData")
        span {{item.voucherData.name}}   
        template(v-if="item.voucherData.code") 
          |  
          span {{item.voucherData.code}}
          
        |   
        currency-view(:value="item.voucherData.value")
      p.title.is-5.is-size-5-mobile(v-else)
        voucher-name-view(v-for="vId in item.vouchers" :value="vId" :key="vId" showNominalValue)
      
      
    template(v-else-if="item.type === 'membership'")
      p.title.is-5
        membership-package-name-view(:value="item.membershipPackage")
    template(v-else-if="item.type === 'service'")
      p.title.is-5
        service-name-view(:value="{service: item.service, option: item.option}")
        
        
    p.subtitle.is-6.mb-2
      template(v-if="item.staff")  
        span.icon
          i.mdi.mdi-account-outline
        staff-view(:id="item.staff")
        span (
          currency-view(:value="item.commission")
        | )
      template(v-else)
        span.icon.has-text-grey
          i.mdi.mdi-account-off-outline
        span.has-text-grey(v-t="'sale.no_staff_label'")
      span(v-if="item.staff && item.resource")   -    
      template(v-if="item.resource")
        span.icon
          i.mdi.mdi-package-variant-closed
        resource-view(:value="item.resource" v-if="item.resource")
      template(v-if="item.duration !== undefined")
        |  -  
        duration-view(:value="item.duration")
    
    ConsumablesList(:value="item.consumables" v-if="item.consumables && item.consumables.length > 0")


  //div(v-if="item.type === 'product'")
    span.icon.is-medium.mr-1
      img(:src="require('../../assets/clipboard.png')")
  

  .is-flex.is-align-items-stretch.py-4(style="flex: 0 0 auto")
    .px-4.has-background-white.is-align-items-center.is-flex.mr-2(v-if="item.type === 'product' || item.type === 'voucher'")  
      div
        button.button.is-rounded.is-small(@click.stop="decreaseQty" style="padding-left: 1em; padding-right: 1em" :disabled="disabled || item.type === 'voucher'")
          span.icon
            i.mdi.mdi-minus.mdi-24px
        button.button.is-white.is-small
          span.is-size-5.has-text-weight-semibold {{item.qty}}  
          
          ProductUnitLabel.is-size-6.ml-1(:product="item.product" v-if="item.type === 'product'")
        button.button.is-rounded.is-small(@click.stop="increaseQty" style="padding-left: 1em; padding-right: 1em" :disabled="disabled || item.type === 'voucher'")
          span.icon
            i.mdi.mdi-plus.mdi-24px
    .is-align-items-center.is-flex.pr-4  
      div  
        p.is-size-7.has-text-weight-semibold(v-if="item.discountType") 
          span.icon.is-small.mr-1
            i.mdi.mdi-percent
          discount-view(:value="item.discountType")
        //- p.is-size-5.has-text-right(v-if="item.membershipDiscount")
        //-   strong.has-text-strikedout 
        //-     currency-view(:value="item.total")
        p.is-size-5.has-text-right
          strong
            currency-view(:value="item.total")
        p.has-text-danger.is-size-6.has-text-right(v-if="item.total !== item.originalTotal")
          span.has-text-strikedout 
            currency-view(:value="item.originalTotal")
        
        
        div.has-text-right(v-if="appliedMembership")          
          CustomerMembershipTagView(:value="appliedMembership._id" v-if="!appliedMembership.isCheckoutPending") 
          span.tag.membership-tag(v-else)
            membership-package-name-view(:value="appliedMembership._id" )
    
    .pr-4.is-align-items-center.is-flex(@click.stop="$emit('remove')" v-if="removable")  
      div.has-text-grey  
        span.is-size-5  
          span.icon
            i.mdi.mdi-trash-can-outline
 
</template>
<script>
import SALE_ITEM_TYPES from '../../../constants/saleItemTypes'
import {mapActions, mapState} from 'vuex'
import saleHelper from '../../../shared/saleHelper'
import CustomerMembershipTagView from '../membership/CustomerMembershipTagView'
import ServiceItemEditModal from './ServiceItemEditModal'
import CreateEditVoucherModal from '../voucher/CreateEditVoucherModal.vue'
import ProductItemEditModal from './ProductItemEditModal'
import ProductUnitLabel from '../inventory/ProductUnitLabel'
import ConsumablesList from './ConsumablesList'
import {cloneDeep} from 'lodash'
import MembershipItemEditModal from './MembershipItemEditModal.vue'
export default {
  name: 'CheckoutItem',
  components: {
    CustomerMembershipTagView,
    ProductUnitLabel,
    ConsumablesList
  },
  props: {
    value: {type: Object, required: true},
    locationId: {type: String, required: true},
    removable: {type: Boolean, default: true},
    saleItems: {type: Array, required: true},
    customerCoupon: {type: Object, default: undefined},
    memberships: {type: Array, default: undefined},
    disabled: {type: Boolean, default: false}
  },
  data() {
    return {
      SALE_ITEM_TYPES,
      item: undefined
    }
  },
  computed: {
    ...mapState('tax', ['taxesMap']),
    ...mapState('company', ['company']),
    ...mapState('location', ['locationsMap']),
    ...mapState('inventory', ['productsMap']),
    priceIncludesTax() {
      return this.company.priceIncludesTax
    },

    appliedMembership() {
      if (this.item.type !== SALE_ITEM_TYPES.SERVICE || !this.memberships) {
        return
      }
      return saleHelper.findEligibleMembership({memberships: this.memberships, item: this.item})
    }
  },
  watch: {
    async value(newVal) {
      if (this.item === newVal) {
        return
      }
      this.item = cloneDeep(newVal)

      await this.update()
    },
    customerCoupon() {
      this.update()
    },
    memberships() {
      this.update()
    }
  },
  async created() {
    this.item = cloneDeep(this.value)
    await this.update()
  },
  methods: {
    ...mapActions('services', ['fetchServiceById']),
    ...mapActions('membershipPackages', ['getMembershipPackageById']),
    ...mapActions('inventory', ['fetchProduct']),
    ...mapActions('staff', ['fetchStaffById']),
    async update() {
      await this.recalculate()
      this.$emit('input', this.item)
    },
    increaseQty() {
      this.item.qty++
      this.update()
    },
    decreaseQty() {
      if (this.item.qty > 1) {
        this.item.qty--
        this.update()
      }
    },
    getConsumableProductsList() {
      if (this.item.type !== SALE_ITEM_TYPES.SERVICE) {
        return []
      }
      return Promise.all(this.item.consumables.map(c => this.fetchProduct(c.product)))
    },
    async recalculate() {
      let taxes = await this.getItemTaxRates()
      let staffMember = this.item.staff && (await this.fetchStaffById(this.item.staff))
      const {commissionRate, commissionBase} = await this.getCommissionCriteria()
      saleHelper.recalculate({
        item: this.item,
        items: this.saleItems,
        taxes,
        priceIncludesTax: this.company.priceIncludesTax,
        customerCoupon: this.customerCoupon,
        commissionRate,
        commissionBase,
        staffMember,
        memberships: this.memberships,
        rewardsEligible: await this.getRewardsEligibility(),
        consumableProductsList: await this.getConsumableProductsList()
      })
    },
    async getRewardsEligibility() {
      if (!this.company.membership.collectFrom || !this.company.membership.collectFrom.includes(this.item.type)) {
        return false
      }
      if (this.item.type === SALE_ITEM_TYPES.SERVICE) {
        let service = await this.fetchServiceById(this.item.service)
        return service.collectRewards !== false
      } else if (this.item.type === SALE_ITEM_TYPES.PRODUCT) {
        let product = await this.fetchProduct(this.item.product)
        return product.collectRewards !== false
      } else if (this.item.type === SALE_ITEM_TYPES.MEMBERSHIP) {
        let membershipPackage = await this.getMembershipPackageById(this.item.membershipPackage)
        return membershipPackage.collectRewards !== false
      }
      return true
    },
    async getCommissionCriteria() {
      let staffMember = this.item.staff && (await this.fetchStaffById(this.item.staff))
      let commissionRate = 0
      let commissionBase = 0
      if (staffMember && staffMember.commission) {
        if (this.item.type === SALE_ITEM_TYPES.SERVICE && staffMember.service) {
          let service = await this.fetchServiceById(this.item.service)
          if (service.commissionRate !== undefined) {
            commissionRate = service.commissionRate
            commissionBase = service.commissionType || staffMember.commission.servicesType
          } else {
            commissionRate = staffMember.commission.services || 0
            commissionBase = staffMember.commission.servicesType
          }
        } else if (this.item.type === SALE_ITEM_TYPES.PRODUCT) {
          let product = await this.fetchProduct(this.item.product)
          if (!product.commission) {
            return {commissionRate, commissionBase}
          }
          if (product.commissionRate !== undefined) {
            commissionRate = product.commissionRate
            commissionBase = product.commissionType || staffMember.commission.retailType
          } else {
            commissionRate = staffMember.commission.retail || 0
            commissionBase = staffMember.commission.retailType
          }
        } else if (this.item.type === SALE_ITEM_TYPES.MEMBERSHIP) {
          let membershipPackage = await this.getMembershipPackageById(this.item.membershipPackage)

          if (membershipPackage.commissionRate !== undefined) {
            commissionRate = membershipPackage.commissionRate
            commissionBase = membershipPackage.commissionType || staffMember.commission.servicesType
          } else {
            commissionRate = staffMember.commission.services || 0
            commissionBase = staffMember.commission.servicesType
          }
        }
      }
      return {commissionRate, commissionBase}
    },
    onItemClick() {
      if (this.disabled) {
        return
      }
      if (this.item.type === SALE_ITEM_TYPES.SERVICE) {
        this.$buefy.modal.open({
          parent: this,
          hasModalCard: true,
          fullScreen: this.isMobile(),
          component: ServiceItemEditModal,
          props: {
            value: this.item,
            saleItems: this.saleItems,
            locationId: this.locationId,
            customerCoupon: this.customerCoupon,
            memberships: this.memberships
          },
          events: {
            input: item => {
              this.item = item
              this.update()
            }
          },
          canCancel: ['escape']
        })
      } else if (this.item.type === SALE_ITEM_TYPES.PRODUCT) {
        this.$buefy.modal.open({
          parent: this,
          hasModalCard: true,
          fullScreen: this.isMobile(),
          component: ProductItemEditModal,
          props: {
            value: this.item,
            saleItems: this.saleItems,
            locationId: this.locationId,
            customerCoupon: this.customerCoupon
          },
          events: {
            input: item => {
              this.item = item
              this.update()
            }
          },
          canCancel: ['escape']
        })
      } else if (this.item.type === SALE_ITEM_TYPES.VOUCHER) {
        this.$buefy.modal.open({
          parent: this,
          hasModalCard: true,
          fullScreen: this.isMobile(),
          component: CreateEditVoucherModal,
          props: {
            voucher: this.item.voucherData
          },
          events: {
            input: voucher => {
              this.item.voucherData = voucher
              this.item.qty = voucher.qty
              this.item.price = voucher.price
              this.item.manualPrice = voucher.price
              this.item.itemPriceBT = voucher.price
              this.item.itemPrice = voucher.price
              this.item.subtotal = voucher.price
              this.item.total = voucher.price

              this.update()
            }
          },
          canCancel: ['escape']
        })
      } else if (this.item.type === SALE_ITEM_TYPES.MEMBERSHIP) {
        this.$buefy.modal.open({
          parent: this,
          hasModalCard: true,
          fullScreen: this.isMobile(),
          component: MembershipItemEditModal,
          props: {
            value: this.item,
            locationId: this.locationId,
            saleItems: this.saleItems,
            customerCoupon: this.customerCoupon,
            memberships: this.memberships
          },
          events: {
            input: item => {
              this.item = item
              this.update()
            }
          },
          canCancel: ['escape']
        })
      }
    },
    async getItemTaxRates() {
      let taxId
      if (this.item.service) {
        let service = await this.fetchServiceById(this.item.service)
        taxId = service.taxes && service.taxes[this.locationId]
      } else if (this.item.product) {
        let product = await this.fetchProduct(this.item.product)
        taxId = product.taxes && product.taxes[this.locationId]
      } else if (this.item.type === SALE_ITEM_TYPES.VOUCHER) {
        let taxDefaults = this.locationsMap[this.locationId].taxDefaults
        if (taxDefaults && taxDefaults.services) {
          taxId = taxDefaults.services
        }
      } else if (this.item.type === SALE_ITEM_TYPES.MEMBERSHIP) {
        let taxDefaults = this.locationsMap[this.locationId].taxDefaults
        if (taxDefaults && taxDefaults.services) {
          taxId = taxDefaults.services
        }
      }

      if (taxId) {
        let tax = this.taxesMap[taxId]
        let items = (tax.items && tax.items.length && tax.items.map(tId => this.taxesMap[tId])) || [tax]
        return items.map(i => {
          return {rate: i.rate, tax: i._id, name: i.name}
        })
      }
      return []
    }
  }
}
</script>
<style scoped>
.checkout-item {
  border: 1px solid #ffffff;
  border-radius: 0px !important;
}
.checkout-item:hover {
  border-color: #625bfe;
  border: 1px solid #625bfe;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}
</style>
